$(document).ready(function () {

    /**
     * Pre-lander funnel
     * If window.location.hash starts with #orderNow
     * ScrollTo Cart
     */
    const hashString = window.location.hash;

    if (hashString.match('^#orderNow')) {
        if ($('#salesBanner').length) {
            let salesBannerHeight = Math.floor($('#salesBanner').height());

            if ($('#salesBanner').hasClass('isStick')) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top - salesBannerHeight
                }, 1000);
            } else {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top
                }, 1000);
            }
        } else {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        }
    }

    /**
     * Mystery Gift v02 Banner scroll to Mystery Gift Section
     */
    if(mysteryGiftV02Component == "true") {
        // console.log($(mysteryBanner));
        // console.log($(mysterySection));
        // console.log('mysteryGiftV02Component: ' + mysteryGiftV02Component);

        $(mysteryBanner).on('click', function (event) {
            $('html, body').animate({
                scrollTop: $(mysterySection).offset().top
            }, 1000);
        });
    }

    //-------------------Take to shooping cart----------------------//
    if ($('#salesBanner').length) {
        let salesBannerHeight = Math.floor($('#salesBanner').height());

        if ($('#salesBanner').hasClass('isStick')) {
            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top - salesBannerHeight
                }, 1000);
            });
        } else {
            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top
                }, 1000);
            });
        }
    } else {
        $('.btn:not(.cta)').on('click', function (event) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);

        });
    }
    //------------------ End Take to Shooping Cart------------------//

    //------------------ stickyCTA ------------------//

    $('#enableSS').on('click', function (event) {
        $('.subscribe-box__default').trigger("click");
        $('#closeDisclaimer').trigger("click");
        //close ss-box
        agreeToSS(true);
    })

    //------------------ End stickyCTA ------------------//

    //-------------------Shooping Cart------------------------------//
    const disclaimerBox = $('#disclaimerBox'),
        disclaimerTrigger = $('#disclaimerTrigger'),
        subscribeMode = $('#subscribeMode');

    //- Select Subscribe option if click on disclaimer box title
    disclaimerTrigger.on("click", function () {
        let checkbox = $('#subscribeCheckbox');
        let cartBtn = $('#cartCta');

        checkbox.toggleClass('checked');
        cartBtn.toggleClass('disabled');
    })

    function agreeToSS(status) {
        let checkbox = $('#subscribeCheckbox');
        let cartBtn = $('#cartCta');
        if (status) {
            checkbox.addClass('checked');
            cartBtn.removeClass('disabled');
        } else {
            checkbox.removeClass('checked');
            cartBtn.addClass('disabled');
        }
    }

    // close disclaimer box
    $('#closeDisclaimer').on('click', function () {
        disclaimerBox.removeClass('subscribe-box__disclaimer--open');
    });

    // activate subscribe prices
    $('.subscribe-box__default').on('click', function () {
        let thisBtn = $(this);
        let cartBtn = $('#cartCta');
        let checkbox = $('#subscribeCheckbox');

        $('.subscribe-box__default').removeClass('active');
        thisBtn.addClass('active');

        disclaimerBox.addClass('subscribe-box__disclaimer--open');

        //- reset all UIs
        if (cartBtn.hasClass('disabled')) {
            cartBtn.removeClass('disabled');
        }

        if (checkbox.hasClass('checked')) {
            checkbox.removeClass('checked');
        }

        if (thisBtn.hasClass('subscribe')) {
            subscribeMode.attr('data-subscribe', 'true');

            if (!cartBtn.hasClass('disabled')) {
                cartBtn.addClass('disabled');
            }

            if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
                disclaimerBox.addClass('subscribe-box__disclaimer--open');
            }

        } else {
            subscribeMode.attr('data-subscribe', 'false')

            if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
                disclaimerBox.removeClass('subscribe-box__disclaimer--open');
            }
        }
        $('.cart__product.active').trigger("click");
    });

    /**
     * Subscribe Mode - checkbox mode
     */
    $('.purchaseMode__input').on('click', function (check) {
        // console.log($(this).is(":checked"));

        let checkboxType;

        if (subscribeMode.attr('data-subscribe') === 'false') {
            // $('#orderNow').attr('data-subscribe', 'true');
            subscribeMode.attr('data-subscribe', 'true');
            checkboxType = true;
            disclaimerBox.addClass('subscribe-box__disclaimer--open');

        } else {
            // $('#orderNow').attr('data-subscribe', 'false')
            subscribeMode.attr('data-subscribe', 'false');
            checkboxType = false;

            // on touch screens
            if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
                disclaimerBox.removeClass('subscribe-box__disclaimer--open');
            }
        }

        this.setAttribute('checked', checkboxType);

        $('.cart__product.active').trigger("click");
    });

    //set prices   
    function activeProduct() {
        let thisProduct = $(this);
        let subscribe = $('#subscribeMode').attr('data-subscribe');

        let price, link, ship, alternativeContentValue, regularity;

        if (subscribe === 'true') {
            price = 'data-subscribe-price';
            link = 'data-subscribe-link';
            ship = 'data-subscribe-shipping';
            regularity = '<span>/month</span>';

            if ($('#alternativeContent').length) {
                alternativeContentValue = '';
            }
        } else {
            price = 'data-price';
            link = 'data-link';
            ship = 'data-shipping';
            regularity = '';

            if ($('#alternativeContent').length) {
                alternativeContentValue = $('#alternativeContent').attr('data-alt-content');
            }
        }

        $('.cart__product').removeClass('active');
        thisProduct.addClass('active');

        if (thisProduct.attr('data-units') === "6" && subscribe === 'subscribe') {
            $('.perJar .value').html(parseFloat(
                (thisProduct.attr(price)) / (thisProduct.attr('data-units')) + 0.01
            ).toFixed(2));
        } else {
            $('.perJar .value').html(parseFloat(
                (thisProduct.attr(price)) / (thisProduct.attr('data-units'))
            ).toFixed(2));
        }

        $('.current .value').html(thisProduct.attr(price) + regularity);
        $('.retailPrice .value').html(thisProduct.attr('data-retail'));
        $('.shipping .value').html(thisProduct.attr(ship));
        $('.cart__image div:not(.cart__imgsrc):not(.cart__gift)').removeClass('show').addClass('hide');
        $('.cart__image .' + thisProduct.attr('data-units') + "").removeClass('hide').addClass('show');

        if ($('#alternativeContent').length) {
            $('#alternativeContent').html(' ' + alternativeContentValue);
        }

        let param = $('.cta').attr('data-param');

        if(thisProduct.attr(link).includes('?') == false) {
            param = '?' + param
        } else {
            param = '&' + param
        }

        $('.cta').attr('href', thisProduct.attr(link) + param);
    };

    $('.cart__product').on('click', activeProduct);
    $('.cart__product.active').trigger("click");
    //------------------ End Shooping Cart-------------------------//

    //-------------------Formula-----------------------------------//
    $('#formula').slick({
        mobileFirst: true,
        variableWidth: false,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        speed: 300,
        centerMode: false,
        slidesToShow: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    infinite: false,
                    slidesToShow: 3,
                    dots: false
                }
            }
        ]
    });
    //------------------ End formula-------------------------------//

    //-------------------Image Touch Slider------------------------//
    $('.imageTouchSlider .slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: true,
        autoplay: true,
        arrows: true,
        prevArrow: '<a class="slick-prev" href="#"><i class="fa fa-angle-left"></i></a>',
        nextArrow: '<a class="slick-next" href="#"><i class="fa fa-angle-right"></i></a>',
        autoplaySpeed: 800,
        autoplaySpeed: 8000,
        pauseOnDotsHover: true,
        appendDots: $(".imageTouchSlider__img"),
        customPaging: function (slick, index) {
            var target = slick.$slides.eq(index).attr('data-location');;
            return '<div class="dot ' + target + '"></div>';
        }
    });
    //------------------ End Image Touch Slider---------------------//


    //-------------------How To Use-----------------------------------//

    $('.howToUse .steps.slider').slick({
        mobileFirst: true,
        variableWidth: false,
        dots: true,
        arrows: false,
        speed: 300,
        centerMode: false,
        slidesToShow: 1,
        initialSlide: 0,
        appendDots: $(".howToUse .steps.buttons"),
        customPaging: function (slick, index) {
            return '<h3> Step ' + (index + 1) + '</h3>';
        },
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    infinite: false,
                    slidesToShow: 3,
                    dots: false
                }
                // settings: 'unslick'       
            }
        ]
    });

    //------------------ End howToUse-------------------------------//

    //-------------------Reviews-----------------------------------//
    $('#reviews').slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        speed: 700,
        autoplaySpeed: 800,
        centerMode: false,
        adaptiveHeight: true
    });
    //------------------ End Reviews-------------------------------//

    /**
     * Featured On Carousel Banner
     */
    if ($('#featuredOnList').length) {
        $('#featuredOnList').slick({
            autoplay: true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            mobileFirst: true,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 7
                    }
                },
                {
                    breakpoint: 850,
                    settings: "unslick"
                }
            ]
        });
    }


    //- Set current Year to footer Copyright
    let thisDate = new Date();
    $('#year').html(thisDate.getFullYear());
});
